import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'attendStyle'
})
export class AttendStylePipe implements PipeTransform {

  transform(value: any, args?: any): any {

    var data = [];
    var index = 0;
    if(args.attenders && args.attenders.length > 0){
      for(var i=0; i < args.attenders.length; i++){
        data.push(args.attenders[i].id);
        console.log(data, args.attenders[i].id,"=====================")
        index = i;
      }
      if(index == args.attenders.length - 1){
        console.log(data, args.user, data.indexOf(args.user))
        if(data.indexOf(args.user) >= 0){
          return "";
        }else{
          return "attendStyle";
        }
      }
    }else{
      return "attendStyle";
    }
  
    //return 'attendStyle';
  }

}
